import {
  GET_USER,
  // ADD_MENU,
  // PUT_MENU,
  // DELETE_MENU,
  API_ERROR,
  GET_USER_SUCCESSFUL,
  USER_CHANGE_PASSWORD,
} from "./actionTypes";

const initialState = {
  loginError: "aaa",
  message: null,
  loading: false,
  userData: {},
  apiError: {},
};

const userProfile = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER:
      state = {
        ...state,
        // menu: action.payload,ssss
        loading: true,
      };
      break;

    case GET_USER_SUCCESSFUL:
      state = {
        ...state,
        userData: action.payload.userData.response,
        loading: false,
      };
      break;
    case USER_CHANGE_PASSWORD:
      state = {
        ...state,
        loading: true,
        apiError:{}
      };
      break;

    // case ADD_MENU:
    //   state = {
    //     ...state,
    //     loading: false,
    //   };
    //   break;

    // case PUT_MENU:
    //   state = { ...state };
    //   break;

    // case DELETE_MENU:
    //   state = { ...state };
    //   break;

    case API_ERROR:
      state = {
        ...state,
        loading: false,
        apiError: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default userProfile;
